<template>
  <v-row>
    <!--title-->
    <v-col cols="12" md="10" offset-md="1">
      <div class="mb-3 body-1 font-weight-medium">
        Введите реквизиты договора на технологическое присоединение
      </div>
    </v-col>
    <!--end of title-->
    <!--2 column form-->
    <!--col 1-->
    <v-col cols="6" md="4" offset-sm="1">
      <!--column inner-->
      <div class="mb-3 body-1 font-weight-medium">Номер договора</div>
      <v-text-field
        outlined
        v-model="dogovorTp"
        :rules="dogovorTpRules"
      ></v-text-field>
      <!--end of column inner-->
    </v-col>
    <!--col 2-->
    <v-col cols="6" md="4" offset-sm="2">
      <!--column inner-->
      <div class="mb-3 body-1 font-weight-medium">Дата договора</div>
      <input-date-picker v-model="dogovorDate"></input-date-picker>

      <!--end of column inner-->
    </v-col>
  </v-row>
</template>

<script>
    import InputDatePicker from '../../common/InputDatePicker'

    export default {
        props: ['income'],
        components: {
            InputDatePicker,
        },
        data: () => ({
            // DATA
            dogovorTp: null,
            dogovorDate: null,
            filledDate: new Date().getTime(),
            // FORM SETTINGS
            dogovorTpRules: [
                value => !!value || 'Поле «Номер договора» обязательно'
            ],
            dogovorDateRules: [
                value => !!value || 'Поле «Дата договора» обязательно'
            ]
        }),
        computed: {
            dataIsValid() {
                return !!this.dogovorTp && !!this.dogovorDate
            }
        },
        methods: {
            transferData() {
                this.$emit('transfer', {
                    dogovorTp: this.dogovorTp,
                    dogovorDate: new Date(this.dogovorDate).getTime(),
                    filledDate: this.filledDate,
                })
              this.$store.dispatch('statements/setConclusionData', {
                dogovorTp: this.dogovorTp,
                dogovorDate: new Date(this.dogovorDate).getTime(),
              })
            },

        },
        created() {
            let keys = Object.keys(this.income);
            keys.forEach(key => {
                this[key] = this.income[key]
            })
        },
        watch: {
            dataIsValid: {
                immediate: true,
                handler: function (value) {
                    this.$emit('lockFwdBtn', !value)
                }
            }
        }
    }
</script>
